import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { MathUtil } from 'src/app/common/util';
import { ResponseObject } from 'src/app/models/response-object.model';
import { AccountService } from 'src/app/services/account.service';

@Component({
  selector: 'app-budget-goals-report',
  templateUrl: './budget-goals-report.component.html',
  styleUrls: ['./budget-goals-report.component.scss']
})
export class BudgetGoalsReportComponent implements OnInit {
  start: any = "";
  end: any = "";
  type = 2;
  option = null;
  loadingChart = false;
  results = [];
  categories = [];
  options = [];

  constructor(
    private toastService: ToastrService,
    private accountService: AccountService
  ) {

  }

  ngOnInit(): void {
    this.getGoalsBudget();
  }

  getGoalsBudget() {
    this.loadingChart = true;
    document.getElementById("budget-goals")['innerHTML'] = "";
    this.accountService.getGoalsBudget().subscribe({
      next: (response: ResponseObject) => {
        this.results = [];
        this.categories = [];
        response.data.forEach((r) => {
          this.results.push(r.totalBudget ? r.totalBudget : 0);
          this.categories.push(`${r.year}-${r.month}`);
        })
        this.buildChart();
        this.loadingChart = false;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al obtener las metas del presupuesto");
      }
    })
  }

  buildChart() {
    const options = {
      chart: {
        height: 350,
        type: 'area',
      },
      dataLabels: {
        enabled: true
      },
      stroke: {
        curve: 'smooth'
      },
      series: [{
        name: 'Metas',
        data: this.results
      }],
      xaxis: {
        type: 'Días',
        categories: this.categories,
      },
      yaxis: {
        labels: {
          formatter: function (val) {
            return MathUtil.formatCurrency(val);
          }
        }

      },
      legend: {
        offsetY: -10,
      }
    }
    if (this.results.length > 0) {
      const chart = new ApexCharts(
        document.querySelector("#budget-goals"),
        options
      );
      chart.render();
    } else {
      this.results = [];
    }
  }
}
